function appdirective() {
  return {
    template: require('./app.html'),
    controller: 'AppCtrl',
    controllerAs: 'app',
  };
}
angular.module('app').directive('app', appdirective);



// WEBPACK FOOTER //
// ./src/app/app.directive.js